<template>
  <div>
    <CCard>
      <CCardHeader>
          {{ $t("Cover Year") }}
        <div class="card-header-actions">
          <CButton
            class="mz-button v2-mz-btn mr-2"
            color="primary"
            v-if="isAdministrator"
            @click="newCoverYear"
          >
            {{ $t("Create") }}
            <em class="ml-2 fa fa-plus color-inherit" />
          </CButton>
        </div>
      </CCardHeader>
      <CCardBody>
      <table-component
        :data="coveryear_data"
        ref="filesTable"
        :columns="Object.keys(tableHeadings)"
        :tableDateFormat="$options.dateFormat"
        :headings="tableHeadings"
        defaultOrderBy=""
      >
      <template #coveryear_id="{ row }">
          {{ $getNumericalValue(row.coveryear_id, 0, '-', null) }}
        </template>
      </table-component>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { ActiveUser } from "@/services/user";
import { COVERYEARS_ENDPOINTS, CoverYearServices } from "@/services/coveryears";
export default {
  name: "CoverYears",
  data() {
    return {
      COVERYEARS_ENDPOINTS,
      CoverYearServices,
      isAdministrator: ActiveUser.isAdministrator(),
      coveryears: [],
      coveryear_data: null,
      tableHeadings: {
        coveryear_id: this.$t("Year"),
        CoverYearTaux: this.$t("GAREAT Rates"),
        CoverYearGroupTaux: this.$t("CCR Rates"),
        CoverYearGroupThreshold: this.$t("CCR Threshold Rates"),
      },
    };
  },
  
  async mounted() {
    const { data } = await this.$request({
      url: COVERYEARS_ENDPOINTS.get_coveryears,
      query: {
          language: this.$store.state.language
      },
    });
    this.coveryear_data = data;
  },
  methods: {
    newCoverYear() {
      this.$router.push({ name: "New Cover Year" });
    }
  },
};
</script>

<style lang="scss" scoped>
.coveryear-card {
  margin: 1em;
  min-width: 375px;
  max-width: 500px;
}
</style>
